import SuccessMessage from './components/SuccessMessage';

const Signup = () => <SuccessMessage />;

export default Signup;
